import { FC } from 'react'
import { downloadTemplateUpdateUser, uploadUpdateMasiveUser } from '../../../../services'
import { ShowSnackBar } from '../../../../../../util/functions'
import { FormMasiveBulk } from '../../../../../../components/UI/Form/MasiveBulk'

const UpdateMasiveUser: FC = () => {
    const handleUpload = async (formData: FormData, bulkLoadId: string): Promise<any> => {
        try {
            const response = await uploadUpdateMasiveUser(formData, bulkLoadId)
            return response
        } catch (error) {
            ShowSnackBar('Hubo un error', 'error')
        }
    }
    return (
        <FormMasiveBulk
            serviceTemplate={downloadTemplateUpdateUser}
            handleSendService={handleUpload}
            textData1='Actualización masiva de CECOs:'
            textData=''
            title='Usuario'
        />
    )
}

export { UpdateMasiveUser }
